import React from 'react';
import { FileText, ExternalLink, Calendar, User, Clock } from 'lucide-react';
export function PagesListArtifact({
  data
}: {
  data: any[];
}) {
  if (!Array.isArray(data) || data.length === 0) {
    return <div className="p-4 text-slate-500 text-sm" data-id="element-278">
        No hay páginas para mostrar.
      </div>;
  }
  return <div className="flex flex-col gap-3 p-4" data-id="element-279">
      {data.map((page, idx) => {
      const title = page.title || 'Página sin título';
      const id = page.id;
      const space = page.space?.name || page.space?.key || 'Espacio desconocido';
      const author = page.history?.createdBy?.displayName || page.author?.displayName || 'Autor desconocido';
      const created = page.history?.createdDate || page.createdAt || 'Fecha desconocida';
      const type = page.type || 'page';
      const status = page.status || 'current';
      return <div key={id || idx} className="bg-slate-900 rounded-xl border border-slate-800 p-4 hover:border-blue-500/50 transition-colors group flex items-start gap-4" data-id="element-280">
            <div className="p-3 rounded-lg bg-blue-900/30 text-blue-400 mt-1 flex-shrink-0 border border-blue-900/50" data-id="element-281">
              <FileText size={20} data-id="element-282" />
            </div>

            <div className="flex-1 min-w-0" data-id="element-283">
              <div className="flex items-start justify-between gap-4 mb-2" data-id="element-284">
                <h3 className="font-bold text-slate-100 group-hover:text-blue-300 transition-colors flex items-center gap-2 truncate" data-id="element-285">
                  <a href="#" className="hover:underline truncate" data-id="element-286">
                    {title}
                  </a>
                  <ExternalLink size={14} className="opacity-0 group-hover:opacity-100 transition-opacity flex-shrink-0" data-id="element-287" />
                </h3>
                <span className="text-[10px] font-bold text-blue-400 bg-blue-950/50 px-2 py-1 rounded border border-blue-900/50 whitespace-nowrap" data-id="element-288">
                  {space}
                </span>
              </div>

              <div className="flex items-center gap-4 text-xs text-slate-400 flex-wrap" data-id="element-289">
                <div className="flex items-center gap-1.5" title="Autor" data-id="element-290">
                  <User size={14} className="text-slate-500" data-id="element-291" />
                  <span className="truncate max-w-[120px]" data-id="element-292">{author}</span>
                </div>
                <div className="flex items-center gap-1.5" title="Fecha de creación" data-id="element-293">
                  <Calendar size={14} className="text-slate-500" data-id="element-294" />
                  <span data-id="element-295">{new Date(created).toLocaleDateString()}</span>
                </div>
                <div className="flex items-center gap-1.5" title="Estado" data-id="element-296">
                  <Clock size={14} className="text-emerald-500" data-id="element-297" />
                  <span className="capitalize" data-id="element-298">{status}</span>
                </div>
                <div className="flex items-center gap-1.5" title="Tipo" data-id="element-299">
                  <span className="uppercase tracking-wider font-semibold text-[10px] bg-slate-800 px-1.5 py-0.5 rounded border border-slate-700" data-id="element-300">
                    {type}
                  </span>
                </div>
              </div>
            </div>
          </div>;
    })}
    </div>;
}